export default "__VITE_ASSET__Dxw25hlA__"